import { render, staticRenderFns } from "./VerDevolucionItems.vue?vue&type=template&id=6a367134&scoped=true&"
import script from "./VerDevolucionItems.vue?vue&type=script&lang=js&"
export * from "./VerDevolucionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a367134",
  null
  
)

export default component.exports